<template>
  <div>
    <b-form-row>
      <b-col lg="12">
        <b-form-group label-size="sm" label="Tipo de Serviço" label-for="tipo_servico_id">
          <v-select
            :disabled="disableState"
            id="tipo_servico_id"
            :options="combos.tiposServico"
            label="tipo_id"
            :reduce="(t) => t.tipo_id"
            :clearable="false"
            v-model="wbs.tipo_servico_id"
            :filter="doFiltroTipoServico"
          >
            <template v-slot:option="option">{{ `${option.tipo_id} - ${option.descricao}` }}</template>
            <template v-slot:selected-option="option">{{ `${option.tipo_id} - ${option.descricao}` }}</template>
            <template #no-options="{}">Sem dados a serem exibidos</template>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group label-size="sm" label="Tipo do Contrato" label-for="tipo_contrato_id">
          <v-select
            :disabled="disableState"
            id="tipo_contrato_id"
            :options="combos.tiposContrato"
            label="tipo_id"
            :reduce="(t) => t.tipo_id"
            :clearable="false"
            v-model="wbs.tipo_contrato_id"
          >
            <template v-slot:option="option">{{ `${option.tipo_id} - ${option.descricao}` }}</template>
            <template v-slot:selected-option="option">{{ `${option.tipo_id} - ${option.descricao}` }}</template>
            <template #no-options="{}">Sem dados a serem exibidos</template>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group label="Item PA" label-size="sm" label-for="item_pa">
          <b-form-input
            :disabled="disableState"
            size="sm"
            maxlength="20"
            id="item_pa"
            v-model="wbs.item_pa"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group label="Status PA" label-size="sm" label-for="ind_status_pa">
          <b-form-select
            :disabled="disableState"
            size="sm"
            v-model="wbs.ind_status_pa"
            :options="cbo_status_pa"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group label="Componente" label-size="sm" label-for="componente">
          <b-textarea :disabled="disableState" no-resize v-model="wbs.componente" maxlength="255" rows="2"></b-textarea>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="4">
        <b-form-group label="Tipo de Contratação" label-size="sm" label-for="ind_tp_contratacao">
          <b-form-select
            size="sm"
            :disabled="disableState"
            v-model="wbs.ind_tp_contratacao"
            :options="cbo_tipo_contratacao"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group label-size="sm" label="2ª Moeda" label-for="moeda_id">
          <v-select
            id="moeda_id"
            :disabled="disableState"
            :options="combos.moedas"
            label="sigla"
            :reduce="(m) => m.moeda_id"
            :clearable="false"
            v-model="wbs.moeda_id"
          >
            <template v-slot:option="option">{{ `${option.sigla}` }}</template>
            <template v-slot:selected-option="option">{{ `${option.sigla}` }}</template>
            <template #no-options="{}">Sem dados a serem exibidos</template>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group label="Cotação Base R$" label-size="sm" label-for="cotacao_base">
          <b-form-input
            size="sm"
            id="cotacao_base"
            value="0"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 4,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
            v-model="wbs.cotacao_base"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group label-size="sm" label="Fonte" label-for="ind_fonte">
          <b-form-select
            @change="onChangeFonte()"
            :disabled="disableState"
            size="sm"
            v-model="wbs.ind_fonte"
            :options="cbo_ind_fonte"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="4">
        <b-form-group label="Categoria Investimento" label-size="sm" label-for="categoria_investimento">
          <b-form-input
            :disabled="disableState"
            size="sm"
            id="categoria_investimento"
            v-model="wbs.categoria_investimento"
            maxlength="20"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group
          :label="this.wbs.ind_fonte < 3 ? 'Fonte Financeira' : 'Fonte Financ. BID'"
          label-size="sm"
          label-for="fonte_financ"
        >
          <b-form-input
            :disabled="disableState"
            size="sm"
            id="fonte_financ"
            v-model="wbs.fonte_financ"
            maxlength="20"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="4" v-show="this.wbs.ind_fonte == 3">
        <b-form-group label="Fonte Financ. ESTADO" label-size="sm" label-for="fonte_financ2">
          <b-form-input
            :disabled="disableState"
            size="sm"
            id="fonte_financ2"
            v-model="wbs.fonte_financ2"
            maxlength="20"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="6">
        <b-form-group label="Órgão" label-size="sm" label-for="orgao">
          <b-form-input
            :disabled="disableState"
            size="sm"
            id="orgao"
            v-model="wbs.orgao"
            maxlength="50"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group label="Unidade Executora" label-size="sm" label-for="unidade_executora">
          <b-form-input
            :disabled="disableState"
            size="sm"
            id="unidade_executora"
            v-model="wbs.unidade_executora"
            maxlength="50"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="6">
        <b-form-group label="Trecho" label-size="sm" label-for="nome_trecho">
          <b-textarea
            :disabled="disableState"
            size="sm"
            no-resize
            rows="3"
            id="nome_trecho"
            v-model="wbs.nome_trecho"
            maxlength="255"
            trim
          >
          </b-textarea>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group label="Local" label-size="sm" label-for="local">
          <b-textarea
            :disabled="disableState"
            size="sm"
            id="local"
            no-resize
            rows="3"
            v-model="wbs.local"
            maxlength="255"
            trim
          ></b-textarea>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group label="Regional" label-size="sm" label-for="regional">
          <b-form-input
            :disabled="disableState"
            size="sm"
            id="regional"
            v-model="wbs.regional"
            maxlength="50"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-form-group label="Objeto" label-size="sm" label-for="objeto">
          <b-textarea :disabled="disableState" no-resize v-model="wbs.objeto" maxlength="5000" rows="3"></b-textarea>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="3">
        <b-form-group label="Valor Contrato/Planejado R$" label-size="sm" label-for="vl_contrato_planej">
          <b-form-input
            disabled
            size="sm"
            id="vl_contrato_planej"
            value="0"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
            v-model="wbs.vl_contrato_planej"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group label="Valor Contrato/Planejado 2ª Moeda" label-size="sm" label-for="vl_contrato_planej_m2">
          <b-form-input
            disabled
            size="sm"
            id="vl_contrato_planej_m2"
            value="0"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
            v-model="wbs.vl_contrato_planej_m2"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group label="Montante Estimado BID %" label-size="sm" label-for="montante_estim_bid">
          <b-form-input
            :disabled="disableState || wbs.ind_fonte != 3"
            size="sm"
            id="montante_estim_bid"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
            maxlength="20"
            value="0"
            v-model="wbs.montante_estim_bid"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group label="Montante Estimado ESTADO %" label-size="sm" label-for="montante_estim_contrapartida">
          <b-form-input
            :disabled="disableState || wbs.ind_fonte != 3"
            size="sm"
            value="0"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
            id="montante_estim_contrapartida"
            v-model="wbs.montante_estim_contrapartida"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="2">
        <b-form-group label="Extensão" label-size="sm" label-for="extensao">
          <b-form-input
            :disabled="disableState"
            size="sm"
            id="extensao"
            v-mask="{
              alias: 'numeric',
              autoUnmask: true,
              greedy: true,
              radixPoint: ',',
              groupSeparator: '.',
              digits: 2,
              digitsOptional: false,
              autoGroup: true,
              allowPlus: false,
              allowMinus: false,
              onUnMask: function(maskedValue) {
                var x = maskedValue.split(',');
                return x[0].replace(/\./g, '') + '.' + x[1];
              },
            }"
            v-model="wbs.extensao"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="1">
        <b-form-group label="Unid.Med." label-size="sm" label-for="un">
          <b-form-input :disabled="disableState" size="sm" maxlength="5" id="un" v-model="wbs.un" trim></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group
          v-show="wbs.ind_tp_contratacao != 3"
          label="Elegibilidade"
          label-size="sm"
          label-for="elegibilidade"
        >
          <b-form-input
            size="sm"
            :disabled="disableState"
            maxlength="50"
            id="elegibilidade"
            v-model="wbs.elegibilidade"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          v-show="wbs.ind_tp_contratacao != 3"
          label="Data da Elegibilidade"
          label-size="sm"
          label-for="dt_elegibilidade"
        >
          <date-picker
            input-class="form-control form-control-sm"
            :clearable="false"
            :disabled="disableState"
            maxlength="10"
            format="DD/MM/YYYY"
            value-type="YYYY-MM-DD"
            v-model="wbs.dt_elegibilidade"
          ></date-picker>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="Situação" label-size="sm" label-for="situacao_diretoria">
          <b-form-select id="situacao_diretoria" :disabled="disableState" size="sm" v-model="wbs.situacao_diretoria">
            <b-form-select-option value="">** NÃO DEFINIDA **</b-form-select-option>
            <b-form-select-option value="PLANEJADO">PLANEJADO</b-form-select-option>
            <b-form-select-option value="EM PREPARAÇÃO">EM PREPARAÇÃO</b-form-select-option>
            <b-form-select-option value="EM LICITAÇÃO">EM LICITAÇÃO</b-form-select-option>
            <b-form-select-option value="EM HOMOLOGAÇÃO">EM HOMOLOGAÇÃO</b-form-select-option>
            <b-form-select-option value="EM CONTRATAÇÃO">EM CONTRATAÇÃO</b-form-select-option>
            <b-form-select-option value="AGUARDANDO ORDEM DE SERVIÇO">AGUARDANDO ORDEM DE SERVIÇO</b-form-select-option>
            <b-form-select-option value="CONTRATO EM ANDAMENTO">CONTRATO EM ANDAMENTO</b-form-select-option>
            <b-form-select-option value="PARALISADO">PARALISADO</b-form-select-option>
            <b-form-select-option value="FINALIZADO">FINALIZADO</b-form-select-option>
            <b-form-select-option value="CANCELADO">CANCELADO</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  name: "TabWBS",
  components: { DatePicker },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true, default: "view" },
    combos: { type: Object, required: true },
  },
  computed: {
    disableState: function() {
      return this.acao == "view";
    },
  },
  data: function() {
    return {
      cbo_status_pa: [
        { value: 1, text: "CONTRATO EM EXECUÇÃO" },
        { value: 2, text: "CONTRATO TERMINADO" },
        { value: 3, text: "PREVISTO" },
        { value: 4, text: "PROCESSO CANCELADO" },
        { value: 5, text: "PROCESSO EM CURSO" },
      ],
      cbo_tipo_contratacao: [
        { value: 1, text: "OBRAS" },
        { value: 2, text: "SERVIÇOS NÃO CONSULTORIA" },
        { value: 3, text: "CONSULTORIA FIRMAS" },
      ],
      cbo_ind_fonte: [
        { value: 1, text: "BID" },
        { value: 2, text: "ESTADO" },
        { value: 3, text: "BID/ESTADO" },
      ],
    };
  },
  methods: {
    onChangeFonte() {
      if (this.wbs.ind_fonte == 1) {
        this.wbs.montante_estim_bid = 100.0;
        this.wbs.montante_estim_contrapartida = 0.0;
      } else if (this.wbs.ind_fonte == 2) {
        this.wbs.montante_estim_bid = 0.0;
        this.wbs.montante_estim_contrapartida = 100.0;
      }
    },
    doFiltroTipoServico(options, search) {
      return options.filter((f) => {
        return (
          f.descricao.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
          f.tipo_id
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) > -1
        );
      });
    },
  },
  mounted() {},
};
</script>

<style></style>
